import React, { Component } from 'react';

class Education extends Component {
  render() {
    if (this.props.resumeEducation && this.props.resumeBasicInfo) {
      var sectionName = this.props.resumeBasicInfo.section_name.education;
      var schools = this.props.resumeEducation.map(function (school, i) {
        return (
          <div className='education-item' key={i}>
            <div className='education-head'>
              <div className='education-name'>
                {school.image ? (
                  <img className='education-logo' src={school.image} alt='' />
                ) : null}
                <h4 className='education-institution'>{school.institution}</h4>
              </div>
              <span className='education-years'>{school.years}</span>
            </div>
            <h5 className='education-degree'>{school.degree}</h5>
            <p className='education-detail font-trebuchet'>{school.detail}</p>
          </div>
        );
      });
    }
    var pub = this.props.resumePublication;

    return (
      <section id='education'>
        <div className='col-md-12'>
          <h1>
            <span>{sectionName}</span>
          </h1>
          <div className='col-md-8 mx-auto'>
            {schools}
            {pub ? (
              <div className='education-item publication-item'>
                <div className='education-head'>
                  <h4 className='education-institution'>Publication</h4>
                </div>
                <h5 className='education-degree'>{pub.venue}</h5>
                <p className='education-detail font-trebuchet'>
                  <a href={pub.url} target='_blank' rel='noopener noreferrer'>
                    {pub.title}
                  </a>
                </p>
              </div>
            ) : null}
          </div>
        </div>
      </section>
    );
  }
}

export default Education;
